export default {
    SERVER_ERROR: "Ha ocurrido un error interno, por favor reporta este incidente a nuestro equipo de soporte.",
    SERVER_UNAVAILABLE: "El servidor no está disponible, contacta a nuestro equipo de soporte.",
    FIREBASE_AUTH: "Firebase no está disponible, la carga y previsualización de imágenes no estarán en funcionamiento.",
}



// WEBPACK FOOTER //
// ./src/constants/errors.js